import Head from 'next/head';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'src/types';

export type Seo = {
  canonical?: string;
  published_time?: string;
  modified_time?: string;
  title?: string;
  description?: string;
  image?: string;
  robots?: string;
  ogTitle?: string;
}

type Head = Seo & {
  extra?: ReactNode;
}

export default function HeadSeo({
  canonical,
  published_time,
  modified_time,
  title = 'HealthUnlocked | The social network for health',
  description = '',
  image,
  robots,
  ogTitle,
  extra = '',
}: Head) {

  const { unreadMessagesCount, unreadNotificationsCount } = useSelector(({context}: State) => context);
  let notifications = '';
  if (unreadMessagesCount || unreadNotificationsCount) {
    notifications = `(${unreadMessagesCount + unreadNotificationsCount}) `;
  }

  return (
    <Head>
      <title>{notifications}{title}</title>
      <meta content={description} name="description"/>
      {!!canonical && <link href={canonical} rel="canonical"/>}
      {!!published_time && <meta content={published_time} property="article:published_time"/>}
      {!!modified_time && <meta content={modified_time} property="article:modified_time"/>}
      {!!image && <meta content={image} property="og:image" />}
      {!!image && <meta content={image} property="og:image:secure_url" />}
      {!!robots && <meta content={robots} property="robots"/>}
      {!!ogTitle && <meta content={ogTitle} property="og:title"/>}
      <meta content={description} property="og:description"/>
      {extra}
    </Head>
  );
}
